import { render, staticRenderFns } from "./ed-list-classes.component.vue?vue&type=template&id=0ed49b80&scoped=true&"
import script from "./ed-list-classes.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-classes.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-classes.component.scss?vue&type=style&index=0&id=0ed49b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed49b80",
  null
  
)

export default component.exports